/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Open Source Version is distributed with Sencha Ext JS pursuant to a FLOSS Exception agreed upon
 * between Sonatype, Inc. and Sencha Inc. Sencha Ext JS is licensed under GPL v3 and cannot be redistributed as part of a
 * closed source work.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import { UIView } from '@uirouter/react';
import { ROUTE_NAMES } from '../routeNames/routeNames';
import { lazyLoad } from './lazyLoad';

// Lazy load all route components for better code splitting
const UserAccount = lazyLoad(() => import('../../components/pages/admin/UserAccount/UserAccount'));
const NuGetApiToken = lazyLoad(() => import('../../components/pages/user/NuGetApiToken/NuGetApiToken'));
const UserToken = lazyLoad(() => import('../../components/pages/user/UserToken/UserToken'));

const USER = ROUTE_NAMES.USER;

// for more info on how to define routes see private/developer-documentation/frontend/client-side-routing.md
export const userRoutes = [
  {
    name: USER.DIRECTORY,
    url: 'user',
    component: UIView,
    data: {
      visibilityRequirements: {
        ignoreForMenuVisibilityCheck: true,
      },
      title: USER.TITLE,
    },
  },

  {
    name: USER.ACCOUNT,
    url: '/account',
    component: UserAccount,
    data: {
      visibilityRequirements: {
        requiresUser: true,
      },
      title: USER.TITLE,
    },
  },

  {
    name: USER.NUGETAPITOKEN,
    url: '/NuGetApiToken',
    component: NuGetApiToken,
    data: {
      visibilityRequirements: {
        requiresUser: true,
        permissions: ['nexus:apikey:*'],
        statesEnabled: [
          {
            key: 'nugetApiKeyRealmEnabled',
            defaultValue: false,
          },
        ],
      },
      title: USER.TITLE,
    },
  },

  {
    name: USER.USER_TOKEN,
    url: '/usertoken',
    component: UserToken,
    data: {
      visibilityRequirements: {
        bundle: 'nexus-usertoken-plugin',
        statesEnabled: [
          {
            key: 'usertoken',
            defaultValue: { enabled: false },
          },
        ],
        permissions: ['nexus:usertoken-current:read'],
        editions: ['PRO'],
      },
      title: USER.TITLE,
    },
  },
];
